<template>
	<div class="carousel-control-wrapper carousel-control__desk">
	  <div class="control-center">
	    <a class="carousel-control-prev">
	      <i class="fa-thin fa-arrow-left fa-2x"></i>
	    </a>
	    <a class="carousel-control-next">
	      <i class="fa-thin fa-arrow-right fa-2x"></i>
	    </a>
	  </div>
	</div>
</template>